import React from 'react';
import {
  Box,
  Cards,
  Container,
  Header,
  PieChart,
  SpaceBetween,
  StatusIndicator,
  ColumnLayout,
} from '@cloudscape-design/components';

// Dummy data for the pie chart
const pieChartData = [
  {
    title: 'Technical Analysis',
    value: 4,
    color: '#688ee0'  // Blue
  },
  {
    title: 'Domain Analysis',
    value: 3,
    color: '#f2b860'  // Orange
  },
  {
    title: 'Microservice Generation',
    value: 1,
    color: '#6aad87'  // Green
  },
  {
    title: 'Completed',
    value: 8,
    color: '#b5c9f8'  // Light Blue
  }
];

// Dummy data for recent updates
const recentUpdates = [
  {
    projectName: 'ECommerce Platform',
    timeAgo: '2 hours ago',
    status: 'In Progress',
    phase: 'Domain Analysis',
    type: 'info'
  },
  {
    projectName: 'Banking Portal',
    timeAgo: '1 day ago',
    status: 'Completed',
    phase: 'Technical Analysis',
    type: 'success'
  },
  {
    projectName: 'CRM System',
    timeAgo: '2 days ago',
    status: 'In Progress',
    phase: 'Microservice Generation (3/5 complete)',
    type: 'warning'
  }
];

const ProjectStatusSummary = () => {
  return (
    <Container
  header={
        <Header
        variant="h2"
        description="Overview of project statuses and recent activities"
        >
        Project Status Summary
        </Header>
    }
    >
    <ColumnLayout columns={2} variant="text-grid">
        {/* Pie Chart Section */}
        <Box>
        <PieChart
            data={pieChartData}
            detailPopoverContent={(datum, sum) => [
            { key: 'Projects', value: datum.value },
            {
                key: 'Percentage',
                value: `${((datum.value / sum) * 100).toFixed(0)}%`
            }
            ]}
            hierarchicalClickable
            innerMetricDescription="Total Projects"
            innerMetricValue={pieChartData.reduce((sum, item) => sum + item.value, 0)}
            size="medium"
            variant="donut"
        />
        </Box>

        {/* Recent Updates Section */}
        <Cards
        trackBy="projectName"
        cardDefinition={{
            header: item => (
            <Box variant="h4">{item.projectName}</Box>
            ),
            sections: [
            {
                content: item => (
                <SpaceBetween size="s">
                    <Box variant="small" color="text-body-secondary">
                    {item.timeAgo}
                    </Box>
                    <StatusIndicator type={item.type}>
                    {item.status}
                    </StatusIndicator>
                    <Box variant="small">
                    Phase: {item.phase}
                    </Box>
                </SpaceBetween>
                )
            }
            ]
        }}
        items={recentUpdates}
        header={
            <Header
            variant="h3"
            >
            Recent Updates
            </Header>
        }
        cardsPerRow={[{ cards: 1 }]} 
        empty="No recent updates"
        stickyHeader={false}
        variant="container"
        margin={{ bottom: 'xxxs' }} 
        cardSpacing={{ vertical: 'xs' }} 
        />
    </ColumnLayout>
    </Container>
  );
};

export default ProjectStatusSummary;
